/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 20:26:17 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-05-16 12:22:33
 */
import { showMessage } from "modules/messages/actions"

import {FETCH_BAD_FIT, FETCH_COUNSELLORS, UPDATE_COUNSELLOR, DELETE_BAD_FIT_ITEM, UPDATE_BAD_FIT_ITEM} from "./actionTypes"
import { getAdminCounsellors, getBadFitItems } from "service/api"
import { adminCounsellors } from "service/selectors"
import { failedMessage } from "service/constants"
import { badFitGrouped } from "../bad-fit/selectors"

export const fetchCounsellors = () => (dispatch) => {
    return getAdminCounsellors()
    .then(
      (counsellors) => {
          const updatedCounsellors = adminCounsellors(counsellors)

          return dispatch(onFetchCounsellorsSuccess(updatedCounsellors))
        },
      (error) => dispatch(showMessage(failedMessage))
    )
}

export const fetchUpdatedCounsellor = (id) => (dispatch) => {
  return getAdminCounsellors(id)
  .then(
    (counsellor) => {
        const updatedCounsellors = adminCounsellors(counsellor)

        return dispatch(onFetchUpdatedCounsellorSuccess(updatedCounsellors))
      },
    (error) => dispatch(showMessage(failedMessage))
  )
}

export const fetchBadFitItems = () => (dispatch) => {
  return getBadFitItems()
  .then(
    (badFitItems) => {
        const badFitGroupedList = badFitGrouped(badFitItems)

        return dispatch(onFetchBadFitSuccess(badFitGroupedList))
      },
    (error) => dispatch(showMessage(failedMessage))
  )
}

export const onFetchUpdatedCounsellorSuccess = (counsellor) => ({
  type: UPDATE_COUNSELLOR,
  counsellor
})

export const onFetchCounsellorsSuccess = (counsellors = []) => ({
  type: FETCH_COUNSELLORS,
  counsellors
})

export const onFetchBadFitSuccess = (badFitItems = []) => ({
  type: FETCH_BAD_FIT,
  badFitItems
})

export const deleteBadFitItem = (id) => ({
  type: DELETE_BAD_FIT_ITEM,
  id
})

export const updateBadItem = (item) => ({
  type: UPDATE_BAD_FIT_ITEM,
  item
})